import * as React from 'react';
import { connect } from 'react-redux';
import { ReportingSetup } from '../../components/pages/reporting-setup/ReportingSetup';
import { IApplicationState } from '../../store';
import { ActionCreators as BenchmarksActionCreators } from '../../store/BenchmarksStore';
import { ActionCreators as BreakoutsActionCreators } from '../../store/BreakoutsStore';
import { ActionCreators as ReportingSetupActionCreators } from '../../store/ReportingSetupStore';
import { SurveyBenchmarkActionCreators } from '../../store/SurveyBenchmarkActionCreators';
import { ActionCreators as SurveyBuilderActionCreators } from '../../store/SurveyBuilderStore';
import { UserFeatureAccessHelper } from '../../utilities/FeatureFlags';
import { ReportingPageStateSetter } from '../state-setter/ReportingPageStateSetter';
import { PageStateSetterRouteProps } from '../state-setter/SurveyPageStateSetterBase';

export const ReportingSetupContainer: React.ComponentType<any> = connect(
	(state: IApplicationState) => ({
		...state.reportingSetup,
		userType: state.oidc.user?.profile.userType,
		...state.benchmarks,
		selectedBenchmarkIds: [...state.survey.surveyEditModel.benchmarks],
		...state.breakouts,
		...state.surveyBuilder,
		clientId: state.survey.surveyEditModel.survey.clientId,
		audienceSourceType: state.survey.surveyEditModel.audienceSource.audienceSourceType,
		hrisId: state.survey.surveyEditModel.audienceSource.externalHrisId,
		userFeatureAccessHelper: new UserFeatureAccessHelper(state.oidc.user),
	}),
	{
		...ReportingSetupActionCreators,
		...SurveyBenchmarkActionCreators,
		...BreakoutsActionCreators,
		...SurveyBuilderActionCreators,
		...BenchmarksActionCreators,
	},
)(ReportingSetup);

export class ReportingSetupPage extends React.PureComponent<PageStateSetterRouteProps> {
	public render() {
		return (
			<>
				<ReportingSetupContainer {...this.props} />
				<ReportingPageStateSetter {...this.props} />
			</>
		);
	}
}
